module.exports = __webpack_public_path__ + "background_partners.jpg";